import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function CustomBarChart({
  dataset,
  xDataKey,
  yDataKey,
  series,
  label,
  otherSetting,
  verticalLabels = false,
}) {
  // Conditional rendering based on dataset length
  if (!dataset || dataset.length === 0) {
    return null; // Return null or some placeholder if no data is available
  }

  return (
    <BarChart
      dataset={dataset}
      width={20} // Consider adjusting this value based on your requirements
      xAxis={[
        {
          scaleType: "band",
          dataKey: xDataKey,
          tickPlacement: "extremities",
          tickLabelPlacement: "middle",
          tickLabelStyle: verticalLabels
            ? {
                angle: 90,
                textAnchor: "start",
                dominantBaseline: "middle",
              }
            : {}, // If verticalLabels is false, an empty object is used
        },
      ]}
      series={[
        {
          dataKey: yDataKey,
          label: label,
        },
      ]}
      {...otherSetting} // Spread other settings as props
    />
  );
}
